var map = {
	"./Cityscape-Roma.jpg": 25,
	"./Cityscape-Wellington-cable-car.jpg": 26,
	"./Landscape-Alicante-mountains.jpg": 27,
	"./Landscape-Autumn-leaf-litter-incineration.jpg": 28,
	"./Landscape-Gozo-Sunset.jpg": 29,
	"./Other-Rooftop.jpg": 30,
	"./Other-Vatican.jpg": 31,
	"./Other-Well.jpg": 32,
	"./Other-Winter-apple.jpg": 33,
	"./Panorama-Alicante-mountains.jpg": 34,
	"./Panorama-An-extinct-volcanic-crater.jpg": 35,
	"./Panorama-Beach-pano.jpg": 36,
	"./Panorama-Domus-Sessoriana.jpg": 37,
	"./Panorama-Fontana-di-Trevi.jpg": 38,
	"./Panorama-Give-me-back-my-mountains.jpg": 39,
	"./Panorama-Hills.jpg": 40,
	"./Panorama-Piha-beach.jpg": 41,
	"./Panorama-St-Peter-Basilica.jpg": 42,
	"./Panorama-Transilvanian-sunset.jpg": 43,
	"./Panorama-Wellington-pano.jpg": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;